import React from "react";
import { Create, FileInput, FileField, SimpleForm, required, useNotify, useRedirect } from "react-admin";
import { Grid } from "@mui/material";

const CreateTradeNetwork = () => {
  const notify = useNotify();
  const redirect = useRedirect();
  const onSuccess = data => {
    notify(`Файлът е качен успешно!`, { type: "success" });
    redirect(`/`);
  };
  const onError = () => {
    notify("Възникна грешка! Моля проверете формата на документа или опитайте по-късно.", { type: "error" });
  };
  return (
    <Create
      mutationOptions={{ onSuccess, onError }}
      title="Създаване на ваучери и карти за услуги от търговска мрежа"
    >
      <SimpleForm>
        <Grid container>
          <Grid
            item
            xs={9}
            md={9}
          >
            <FileInput
              placeholder="Добавете файл с обекти в XLS формат"
              label="Обекти"
              source="file"
              accept=".xls , .xlsx"
              validate={required()}
            >
              <FileField
                source="src"
                title="title"
                label={null}
              />
            </FileInput>
          </Grid>
        </Grid>
      </SimpleForm>
    </Create>
  );
};

export default CreateTradeNetwork;
